import PageViewer from "./PageViewer";

function Content(props) {
	//variables
	const content = props.content.find(
		(element) => element.ID === props.currentContentId
	)?.CONTENT;

	return (
		<>
			<div className='content-inner'>
				{content ? <PageViewer content={content} /> : null}
			</div>
		</>
	);
}

export default Content;
